export const styles = {
    showButton: {
        py: 1,
        p: {
            textDecoration: "underline",
            fontSize: ["mobileBodyB2", "desktopH4"],
            fontWeight: "bold",
        },
    },
};
